/**
 * Câu lỗi tiếng Việt cho trang PK. Interceptor của AxiosUtils ném thẳng body lỗi của
 * server: lỗi nghiệp vụ mới (ApprovalError, vd. PK_ALREADY_STARTED, PK_START_IN_PAST,
 * PK_NOTIFY_GROUP_NOT_ALLOWED, PK_ROLE_NOT_ALLOWED) có câu ở `error`, mã ở `message`.
 */
const GENERIC =
  /^(Bad Request|Not Found|Conflict|Forbidden|Unauthorized|Too Many Requests|Internal Server Error|Service Unavailable)$/i;

export const pkErrorText = (err: any, fallback = 'Có lỗi xảy ra, vui lòng thử lại.'): string => {
  if (err?.networkError) return 'Không kết nối được máy chủ.';
  if (Number(err?.statusCode) === 429) {
    return 'Thao tác quá nhanh, vui lòng đợi vài giây rồi thử lại.';
  }
  if (typeof err?.error === 'string' && err.error && !GENERIC.test(err.error)) return err.error;
  if (err?.message === 'PK_NOT_FOUND') return 'Không tìm thấy trận PK (có thể đã bị xoá).';
  return fallback;
};
